import React, {useEffect, useRef, useState} from "react";
/** @jsxImportSource @emotion/react */
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import {useTheme} from "@emotion/react";
import {BROADCAST_ON_PASS_MOBILE_HEADER_TITLE, useApplicationContext} from "../../context/ApplicationContextProvider";
import {HEADER_TYPE_BASE} from "../_common/section/Header";
import {FOOTER_TYPE_NONE} from "../_common/section/Footer";
import UpdateAccountForm from "./component/UpdateAccountForm";
import {useLocation} from "react-router-dom";
import UpdatePasswordForm from "./component/UpdatePasswordForm";
import {useMobileDetect} from "../../utils/Hooks";

const ContainerUpdateAccount = () => {
    // ApplicationContext
    useApplicationContext({
        header: {
            type: HEADER_TYPE_BASE,
        },
        footer: {
            type: FOOTER_TYPE_NONE,
        },
    });

    const {is_mobile} = useMobileDetect();
    const {broadcast} = useApplicationContext();
    const location = useLocation();

    // state
    const [is_update_password, setIsUpdatePassword] = useState();

    // ref
    const path_name = useRef();

    // css style
    const {css, view} = useComponentStyle(is_mobile);

    useEffect(() => {
        path_name.current = location.pathname;
        if (path_name.current.split("/").includes("update-info")) {
            setIsUpdatePassword(false);
            broadcast.send(BROADCAST_ON_PASS_MOBILE_HEADER_TITLE, "개인정보 수정");
        } else {
            setIsUpdatePassword(true);
            broadcast.send(BROADCAST_ON_PASS_MOBILE_HEADER_TITLE, "비밀번호 변경");
        }
    }, [path_name, location.pathname, broadcast]);

    return (
        <div css={css.modify_account_container_css}>
            {!is_mobile && (
                <view.TitleSection>
                    <view.Title>{is_update_password ? "비밀번호 변경" : "개인정보 수정"}</view.Title>
                </view.TitleSection>
            )}
            {is_update_password ? <UpdatePasswordForm /> : <UpdateAccountForm />}
        </div>
    );
};

export default ContainerUpdateAccount;

export const useComponentStyle = (is_mobile) => {
    const theme = useTheme();
    return {
        css: {
            modify_account_container_css: css({
                width: "95%",
                maxWidth: "400px",
                height: "100%",
                margin: "0 auto",
                minWidth: "15em",
                marginTop: is_mobile && "6em",
            }),
        },
        view: {
            TitleSection: styled.div({
                display: "block",
                width: "100%",
                textAlign: "center",
            }),
            Title: styled.div({
                fontSize: theme.font_size.f22,
                fontWeight: "700",
                margin: "1.5em 0 3em 0",
            }),
        },
    };
};
